import moment from 'moment';

export function getDayPosition(date, daysArray) {
  const target = moment(date).startOf('day');

  for (let i = 0; i < daysArray.length; i++) {
    const current = moment(daysArray[i].date).startOf('day');
    if (current.isSame(target)) {
      return i;
    }
  }

  return -1; // Not found
}
